import type { Dispatch } from '@reduxjs/toolkit';
import { setScene, updateScene } from '../store/appSlice';
import type { TSceneJsonDto } from '../domain/scene/sceneJsonDto';
import { importScene } from '../viewer/importScene';

export const setSceneFromId = async (dispatch: Dispatch, id: string) => {
  // fetch scene JSON
  const response = await fetch(`files/scenes/${id}/scenePlayground.json`);

  const { status } = response;
  if (status < 200 || status >= 400) {
    throw new Error();
  }

  const scene: TSceneJsonDto = await response.json();
  setSceneFromJson(dispatch, scene);
};

export const setSceneFromJson = async (dispatch: Dispatch, sceneDto: TSceneJsonDto) => {
  // import scene JSON
  const scene = await importScene(sceneDto);
  // set scene
  setScene(scene);
  // notify scene update
  dispatch(updateScene());
};
